import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import merge from 'deepmerge'
import { compactAndFilter } from '@/utils'

const module = 'cities'
let doc = {
  list: {
    name: 'Villes',
    headers: [
      { label: 'Nom', value: 'name' },
      { label: 'Région', value: 'region.name' },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['cities.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
      { icon: 'pie_chart', context: {field: 'city_id'}, dispatch: `tenancy/getTenancy` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['cities.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
      {
        label: 'Occupation',
        icon: 'pie_chart',
        dispatch: `tenancy/getMultiTenancy`,
        context: {field: 'city_id'},
      },
    ],
    search: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Region', type: 'multilist', name: 'region_id', from: 'name', source: 'regions' },
    ],

  },
  form: {
    name: 'Ville',
    hasPhoto: true,
    fields: [
      { label: 'Nom', type: 'text', name: 'name' },
      { label: 'Region', type: 'list', from: 'name', name: 'region_id', source: 'regions' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, scope: ['cities.update'], dispatch: `${module}/update` },
      {
        icon: 'delete',
        scope: ['cities.delete'],
        isFlat: true,
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    relations: [
      {
        name: 'Districts',
        source: 'districts',
        headers: [
          { label: 'Nom', value: 'name' },
        ],
        dispatch: 'getDistricts',
        dataActions: [
          { icon: 'visibility', isFlat: false, dispatch: `districts/goTo` },
        ],
      },
    ],
  },

  params: {
    fetchAll: {include: 'region'},
    fetchOne: {include: 'region'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    getDistricts: ({ commit }, payload) => {
      const { context, data } = payload
      commit('SET_LOADING', true)
      commit('districts/LIST_REQUEST', payload, {root: true})
      let compacted = compactAndFilter(data)
      let params = {
        ...compacted,
        city_id: context.id,
      }
      apiClient.fetchCustom('districts', `districts`, params)
        .then(data => {
          commit('districts/LIST_SUCCESS', data, {root: true})
          commit('SET_LOADING', false)
        })
        .catch(error => {
          commit('districts/LIST_ERROR', error, {root: true})
          commit('SET_LOADING', false)
        })
    },
  },
}

export default merge(base, custom)
